<template>
	<footer class="footer">
		<div class="con_box">
			<div class="left">
				<ul>
					<h3>{{langtrans().yhdl[languageIndex]}}</h3>
					<li class="a" @click="login(0)">{{langtrans().jyjg[languageIndex]}}</li>
					<li class="a" @click="login(2)">{{langtrans().jjgjg[languageIndex]}}</li>
					<li class="a" @click="login(1)">{{langtrans().zzzhzz[languageIndex]}}</li>
				</ul>
				<ul>
					<h3>{{langtrans().gy[languageIndex]}}</h3>
					<router-link class='a' tag='li' to='/aboutus'>{{langtrans().gsjj[languageIndex]}}</router-link>
					<router-link class='a' tag='li' to='/news'>{{langtrans().xwzzx[languageIndex]}}</router-link>
					<router-link class='a' tag='li' to='/contact'>{{langtrans().hgzzzz[languageIndex]}}</router-link>
				</ul>
				<ul>
					<h3>{{langtrans().lxj[languageIndex]}}</h3>
					<router-link class='a' tag='li' to='/feedback'>{{langtrans().yjxfk[languageIndex]}}</router-link>
					<li>{{langtrans().kffrx[languageIndex]}}：+86-10-83423665</li>
					<li>{{langtrans().zzzhzz1[languageIndex]}}：+86-10-83423665</li>
				</ul>
			</div>
      <!-- 三级等保注释 -->
			<div class="right">
				<ul>
					<li>{{langtrans().xzzddj[languageIndex]}}</li>
					<li>
						<img src="./../../../static/img/rq_code_dow.png" alt="langtrans().ddjxew[languageIndex]">
					</li>
				</ul>
				<ul>
					<li>{{langtrans().wwxsgz[languageIndex]}}</li>
					<li>
						<img src="./../../../static/img/rq_code_public.png" alt="langtrans().ddjxww[languageIndex]">
					</li>
				</ul>
			</div>
		</div>
		<div class="footer_bottom">
			{{langtrans().ddjxbq[languageIndex]}}@2018 备案号：<a href="http://www.miitbeian.gov.cn/">京ICP备2025140282号-1</a>
		</div>
	</footer>
</template>

<script>
import langtrans from "@/assets/languagejs/indexFooter.vue.trans.js";	
	export default{

		computed:{
			languageIndex(){
				return this.$store.state.language
			}
		},
		methods:{
			langtrans(){
				return langtrans
			},
			login(str){
				this.$emit('performHeader',str)
			}
		}
	}

</script>

<style scoped="scoped">
	.con_box {
		width: 100%;
		box-sizing: border-box;
		padding: 4vw 15vw 30px 15vw;
		overflow: hidden;
		background-color: white;
	}
	a{color:#999;text-decoration: none;}
	.con_box .left{float: left;overflow: hidden;}
	.con_box .left >ul{float: left;width: 165px;}
	.con_box .left >ul h3{font-size: 16px;color: #333;margin-bottom: 20px;}
	.con_box .left >ul li{color: #666;font-size: 14px;line-height: 35px;}
	.con_box .left >ul li:hover{color: #333;}
	.con_box .left >ul:last-child{width: 276px;}
	.con_box .right{float: right;width: 380px;overflow: hidden;}
	.con_box .right ul{width: 160px;text-align: center;float: left;font-size: 16px;color: #333;}
	.con_box .right ul:first-child{margin-right: 60px;}
	.con_box .right ul li:first-child{margin-bottom:30px;white-space: nowrap;}
	.con_box .right ul li img{width: 120px;}
	.footer_bottom{background-color: #f2f2f2;padding: 10px 0;text-align: center;font-size: 16px;color: #999;}
	.a{cursor: pointer;}
</style>



// WEBPACK FOOTER //
// src/components/footer/indexFooter.vue